import { StorageKeyObserver } from "shared/StorageKeyObserver";

export class UserActivityEventListener {

	constructor(private userActivityObserver: StorageKeyObserver<number>) {
		this.userActivityObserver.value = Date.now();
	}

	public listen(): void {
		[ "keydown", "keyup", "touchstart", "touchend", "mousedown", "mouseup" ].forEach(e => {
			document.body.addEventListener(e, () => this.userActivityObserver.value = Date.now());
		});
	}
}
